export const environment = {
  production: false,
  apiUrl: '//localhost:8000/api'
};
